import { Modal } from "antd"
import React from "react"
import type { ModalProps } from "antd"
import { H7 } from "components/typography/H7"

interface Props extends Omit<ModalProps, "title" | "footer"> {
  title: string | React.ReactNode
  subtitle?: string | React.ReactNode
  footer?: React.ReactNode | null
  titleIcon?: React.ReactNode
  titleClassName?: string
  subtitleClassName?: string
  bodyClassName?: string
  footerClassName?: string
}

const CustomModal = ({
  title,
  footer,
  titleIcon,
  children,
  subtitle,
  titleClassName,
  subtitleClassName,
  bodyClassName,
  footerClassName,
  ...rest
}: Props) => {
  return (
    <Modal
      title={
        <div className="flex gap-2 px-4 md:px-6 p-4 border-b">
          {titleIcon}
          <div>
            <H7 className={titleClassName ?? "font-medium text-neutral600"}>
              {title}
            </H7>

            <p
              className={
                subtitleClassName ?? "text-neutral100 text-sm font-light"
              }
            >
              {subtitle}
            </p>
          </div>
        </div>
      }
      footer={null}
      wrapClassName="[&_.ant-modal-content]:!p-0"
      {...rest}
    >
      <div className={bodyClassName ?? "mt-4 px-4 pb-4 md:px-6"}>
        <div className="f">{children}</div>
      </div>

      {footer ? (
        <div
          className={
            footerClassName ?? "mt-6 w-full border-t p-4 px-4 md:px-6"
          }
        >
          {footer}
        </div>
      ) : null}
    </Modal>
  )
}

export default CustomModal
